import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { GeneralAdsPage } from '../../GeneralAdsPage';
import { setError } from '../../../actions';

interface ItemsAllProps {
  sortingValue?: string;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
});

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type CombinedProps = ItemsAllProps & PropsFromRedux;

const ItemsAllComponent: React.FC<CombinedProps> = ({
  sortingValue,
  setErrorUI
}) => {
  return (
    <GeneralAdsPage
      transformedObj={{ sorting: sortingValue, filter: {} }}
      setErrorUI={setErrorUI}
      isItemsAllPage={true}
    />
  );
};

export const ItemsAll = connector(ItemsAllComponent);
